var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { RequestClient } from '../basics/request-client.service';
import { autoinject } from 'aurelia-framework';
import { Api } from '../../constants/modules/api.constants';
import * as Enumerable from 'linq';
import { TokenClient } from '../authentication/token-client.service';
import { ConfigClientService } from './client-config.service';
import { LotteryTags } from '../../models/modules/lotteryplatform-client.models';
import { toNative, toNativeVoid } from '../../utilities/promise-utils';
var BrandClientService = /** @class */ (function () {
    function BrandClientService(requestClient, tokenClient, configClientService) {
        this.requestClient = requestClient;
        this.tokenClient = tokenClient;
        this.configClientService = configClientService;
    }
    BrandClientService.prototype.getBrandOrOperatorStats = function (brandId, operatorId, showAll) {
        return toNative(this.requestClient.get(Api.ManageBrands.getStats, { brandId: brandId, operatorId: operatorId, showAll: showAll }));
    };
    BrandClientService.prototype.getBrand = function (request) {
        return toNative(this.requestClient.get(Api.ManageBrands.Get, request));
    };
    BrandClientService.prototype.getTemplates = function () {
        return toNative(this.requestClient.get(Api.ManageBrands.GetTemplates, {}));
    };
    BrandClientService.prototype.getLotteryWidgets = function () {
        return toNative(this.requestClient.get(Api.ManageBrands.GetLotteryWidgets, {}));
    };
    BrandClientService.prototype.getBrandCurrencies = function (request) {
        return toNative(this.requestClient.get(Api.ManageBrands.GetBrandCurrencies, request));
    };
    BrandClientService.prototype.delete = function (request) {
        return toNative(this.requestClient.post(Api.ManageBrands.Delete, {}, request));
    };
    BrandClientService.prototype.recordAffiliateLink = function (item) {
        return toNative(this.requestClient.post(Api.AffiliateLinkAnalytic.Record, {}, item));
    };
    BrandClientService.prototype.removeTheme = function (id) {
        return toNative(this.requestClient.post(Api.ManageBrands.DeleteBrandTheme + "/" + id, {}, {}));
    };
    BrandClientService.prototype.save = function (request) {
        return toNative(this.requestClient.post(Api.ManageBrands.Save, {}, request));
    };
    BrandClientService.prototype.saveTemplates = function (request) {
        return toNative(this.requestClient.postFormData(Api.ManageBrands.SaveTemplates, request));
    };
    BrandClientService.prototype.saveLotteryWidgets = function (request) {
        return toNative(this.requestClient.postFormData(Api.ManageBrands.SaveLotteryWidgets, request));
    };
    BrandClientService.prototype.AreMarginValuesValid = function (request) {
        return toNative(this.requestClient.postFormData(Api.ManageBrands.AreMarginValuesValid, request));
    };
    // changed return type from `any` -> `Promise<boolean>` to match the post<T> below
    BrandClientService.prototype.manageBrandLotterySubscriptions = function (brandId, operatorId, configs) {
        return toNative(this.requestClient.post(Api.ManageBrands.ManageBrandLotterySubscriptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
            lotterySubscriptions: configs
        }));
    };
    BrandClientService.prototype.getLotteryBrandSubsciptions = function (brandId, operatorId) {
        return toNative(this.requestClient.post(Api.ManageBrands.GetLotteryBrandSubsciptions, {}, { brandId: brandId, operatorId: operatorId }));
    };
    BrandClientService.prototype.manageOperatorLotteriesForPricing = function (operatorId, lotteryIds) {
        return this.requestClient.post(Api.ManageBrands.ManageOperatorLotteriesForPricing, {}, {
            operatorId: operatorId,
            lotteryIds: lotteryIds
        });
    };
    BrandClientService.prototype.diff = function (obj1, obj2) {
        var e_1, _a;
        if (Array.isArray(obj2)) {
            if (obj1 == null || obj1 == undefined)
                return obj2;
            var newObj = null;
            try {
                for (var obj2_1 = __values(obj2), obj2_1_1 = obj2_1.next(); !obj2_1_1.done; obj2_1_1 = obj2_1.next()) {
                    var item = obj2_1_1.value;
                    var key = item.key;
                    var obj = obj1.filter(function (x) { return x.key == key; })[0];
                    var difference = this.diff(obj, item);
                    if (difference != null) {
                        if (!newObj)
                            newObj = [];
                        difference.key = key;
                        newObj.push(difference);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (obj2_1_1 && !obj2_1_1.done && (_a = obj2_1.return)) _a.call(obj2_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return newObj;
        }
        else if (Object.prototype.toString.call(obj2).toLowerCase() == "[object object]") {
            var newObj = null;
            if (obj1 == null || obj1 == undefined)
                return obj2;
            for (var x in obj2) {
                var difference = this.diff(obj1[x], obj2[x]);
                if (difference != null) {
                    if (!newObj)
                        newObj = {};
                    newObj[x] = difference;
                }
            }
            return newObj;
        }
        else {
            if (obj1 == obj2)
                return null;
            return obj2;
        }
    };
    BrandClientService.prototype.manageBrandInstantGameSubscriptions = function (brandId, operatorId, configs) {
        return this.requestClient.post(Api.ManageBrands.ManageBrandInstantGameSubscriptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
            instantGameSubscriptions: configs
        });
    };
    BrandClientService.prototype.getInstantGameBrandSubsciptions = function (brandId, operatorId) {
        return toNative(this.requestClient.post(Api.ManageBrands.GetInstantGameBrandSubsciptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
        }));
    };
    BrandClientService.prototype.getSweepstakeBrandSubsciptions = function (brandId, operatorId) {
        return toNative(this.requestClient.post(Api.ManageBrands.GetSweepstakeBrandSubsciptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
        }));
    };
    BrandClientService.prototype.manageBrandSweepstakeSubscriptions = function (brandId, operatorId, configs) {
        return this.requestClient.post(Api.ManageBrands.ManageBrandSweepstakeSubscriptions, {}, {
            brandId: brandId,
            operatorId: operatorId,
            sweepstakeSubscriptions: configs
        });
    };
    BrandClientService.prototype.topup = function (brandId, topUpAmount) {
        return toNativeVoid(this.requestClient.post("".concat(Api.ManageBrands.Topup, "/").concat(brandId), {}, {
            amount: topUpAmount
        }));
    };
    BrandClientService.prototype.getInsuranceAccounts = function () {
        return toNative(this.requestClient.get(Api.ManageBrands.GetInsuranceAccounts));
    };
    BrandClientService.prototype.getBrandInsuranceAccountId = function (brandId) {
        return toNative(this.requestClient.get("".concat(Api.ManageBrands.GetBrandInsuranceAccountId, "/").concat(brandId)));
    };
    BrandClientService.prototype.setInsuranceAccount = function (brandId, insuranceAccountId) {
        return toNativeVoid(this.requestClient.post("".concat(Api.ManageBrands.SetInsuranceAccount, "/").concat(brandId), {}, { insuranceAccountId: insuranceAccountId }));
    };
    BrandClientService.prototype.validateBrandLotteryMarginCost = function (brandId) {
        return toNative(this.requestClient.get("".concat(Api.ManageBrands.ValidateBrandLotteriesMarginCost, "/").concat(brandId), {}));
    };
    BrandClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [RequestClient, TokenClient, ConfigClientService])
    ], BrandClientService);
    return BrandClientService;
}());
export { BrandClientService };
var LotteryKeyHelper = /** @class */ (function () {
    function LotteryKeyHelper() {
    }
    LotteryKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    return LotteryKeyHelper;
}());
export { LotteryKeyHelper };
var BundleKeyHelper = /** @class */ (function () {
    function BundleKeyHelper() {
    }
    BundleKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    BundleKeyHelper.getBundleByKey = function (bundles, key) {
        var _this = this;
        var lotteriesEnumerable = Enumerable.from(bundles);
        if (key == LotteryTags.HighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).firstOrDefault();
            return topLottery;
        }
        else if (key == LotteryTags.SecondHighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).skip(1).firstOrDefault();
            return topLottery;
        }
        else if (key == LotteryTags.ThirdHighestJackpot) {
            var topLottery = lotteriesEnumerable.orderByDescending(function (lottery) { return lottery.totalJackpot; }).skip(2).firstOrDefault();
            return topLottery;
        }
        else {
            var lotteryByName = lotteriesEnumerable.firstOrDefault(function (x) { return _this.getKey(x.name) == key; });
            return lotteryByName;
        }
    };
    return BundleKeyHelper;
}());
export { BundleKeyHelper };
var SyndicateKeyHelper = /** @class */ (function () {
    function SyndicateKeyHelper() {
    }
    SyndicateKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    return SyndicateKeyHelper;
}());
export { SyndicateKeyHelper };
var InstantGameKeyHelper = /** @class */ (function () {
    function InstantGameKeyHelper() {
    }
    InstantGameKeyHelper.getKey = function (key) {
        if (key)
            return key.toLowerCase()
                .replace(/ /g, '-')
                .replace(/\//g, '-')
                .replace(/\\/g, '-');
        return key;
    };
    return InstantGameKeyHelper;
}());
export { InstantGameKeyHelper };
var BrandingType = /** @class */ (function () {
    function BrandingType() {
    }
    BrandingType.Text = 'text';
    BrandingType.Colors = 'color';
    BrandingType.Images = 'image';
    BrandingType.Featured = 'featured';
    BrandingType.HotLotteries = 'hot-lotteries';
    BrandingType.CarouselLotteries = 'carousel-lotteries';
    BrandingType.QuickPlay = 'quick-play';
    BrandingType.CarouselScratchcards = 'carousel-scratchcards';
    BrandingType.InstantGameCards = 'instant-game-cards';
    return BrandingType;
}());
export { BrandingType };
var TemplateType = /** @class */ (function () {
    function TemplateType() {
    }
    TemplateType.Overlay = 'overlay';
    TemplateType.Ticket = 'ticket';
    TemplateType.Template = 'template';
    TemplateType.Cart = 'cart';
    TemplateType.Lobby = 'lobby';
    TemplateType.Config = 'config';
    TemplateType.Results = 'results';
    TemplateType.Ads = 'ads';
    TemplateType.Lottery = 'lotteries';
    TemplateType.InstantGame = 'instant-games';
    TemplateType.Bundle = 'bundles';
    TemplateType.Syndicate = 'syndicates';
    TemplateType.Assets = 'assets';
    TemplateType.Purchases = 'purchases';
    TemplateType.ExternalTermsAndConditions = 'external-terms-and-conditions';
    return TemplateType;
}());
export { TemplateType };
